exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.coupon-content[data-v-1807261e] {\n  padding: 0.4rem 0.533333rem;\n  text-align: left;\n}\n.coupon-content .coupon-info[data-v-1807261e] {\n  font-size: 0.373333rem;\n  padding-bottom: 0.266667rem;\n}", ""]);

// exports
